import script from "./NotificationMoveAllConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationMoveAllConfirm.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationMoveAllConfirm.vue?vue&type=style&index=0&id=63e846d9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63e846d9"]])

export default __exports__